import { EnumToArrayValues } from '@vestico/utils';

import { i18n } from '@vestico/i18n';

import { Gender } from './users/constants';

export function genderOptionTitles(): string[] {
  const enumArray = EnumToArrayValues(Gender);
  return enumArray.filter((g) => g !== Gender.unset).map((gender) => stringForGender(gender));
}

export function stringForGender(gender: Gender) {
  switch (gender) {
    case Gender.female:
      return i18n.t('LOC_GENDER_ID_WOMAN', { ns: 'model' });
    case Gender.male:
      return i18n.t('LOC_GENDER_ID_MAN', { ns: 'model' });
    case Gender.unset:
      return i18n.t('LOC_GENDER_ID_UNSET', { ns: 'model' });
    default:
      throw new Error('Unknown gender');
  }
}
